import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { MatPaginator, MatSort, PageEvent, MatSortable } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { AppStateService } from '../services/app-state.service';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { environment } from '../../environments/environment';
import { Budget } from './interfaces';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/distinctUntilChanged';
import { ProjectNrPipe } from '../shared/pipes/project-nr.pipe';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-budget-list',
  templateUrl: './budget-list.component.html',
  styleUrls: ['./budget-list.component.css']
})
export class BudgetListComponent implements OnInit, OnDestroy, AfterViewInit {
  // For the mat-table
  displayedColumns = ['status', 'projectNr', 'manager', 'budgetNr', 'pwName', 'pwCompanyName', 'author', 'creation', 'deliveryThr'];
  dataSource: BudgetDataSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // Set our default values
  public localState = { value: '' };
  public hiddenvalue = 0;
  public budgets: Budget[] = [];
  private userId;
  private dataSubscription;
  private budgetStream$: Observable<any>;

  private budgetFilter;

  get showExport(): boolean {
    if (this.dataSource) {
      return this.dataSource.showExport;
    }
  }

  // TypeScript public modifiers
  constructor(
    // private mapService: MapService,
    private dataService: DataService,
    public appState: AppStateService,
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private projectNrPipe:  ProjectNrPipe,
    private authService: AuthService
  ) {

  }

  public getListFilter() {
    let listFilter = localStorage.getItem('budgetListFilter') ? localStorage.getItem('budgetListFilter') : '';
    this.applyFilter(listFilter);
    return listFilter;
  }

  public setListFilter(filterName, filterValue) {
    localStorage.setItem(filterName, filterValue);
  }

  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    this.setListFilter('budgetListFilter', filterValue);
  }

  applyShowExport(showExport: any) {
    this.dataSource.showExport = showExport.checked;
  }

  applyIconFilter(iconFilter: string) {
    this.dataSource.iconFilter = iconFilter;
  }

  setIconFilter(iconFilter){
    const filter = (iconFilter != this.dataSource.iconFilter) ? iconFilter : '';
    sessionStorage.setItem('budgetListIconFilter', filter);
    this.applyIconFilter(filter);
  }

  public getRowClass(row) {
    return {
      'budget-offer-won': row.offerWon === 'S'
    };
  }

  public ngOnInit() {

    
    
    

    console.log('Init List');

    //this.dataService.getBrokenOrders();

    this.budgetStream$ = this.route.queryParamMap
    .map((queryParamMap) => {
      if (queryParamMap.has('new') && queryParamMap.get('new')) {
        return 'new';
      } else {
        return null;
      }
    })
    // .do((qpm) => {console.log('qpm', qpm); })
    .distinctUntilChanged((a, b) => {
      console.log('duc', a, b);
      return false;
    })
    .switchMap((filter) => {
      // console.log('filter', filter);
      const f = filter ? {'status': filter} : undefined;
      return this.dataService.getBudgetList(f);
    });
    
    this.budgetStream$.first().subscribe(() => {
      setTimeout(function () {
        console.log('scrolling to', Number(sessionStorage.getItem('budgetListScrollPosition')));
        window.scrollTo(0, Number(sessionStorage.getItem('budgetListScrollPosition')));

        window.addEventListener('scroll', this.scrollHandler, true);
      }.bind(this), 500);
    })

    this.budgetStream$.subscribe(data => {
      console.log('budget stream', data);
      
      
      
    });
    // Assign the data to the data source for the table to render
    this.dataSource = new BudgetDataSource(
      this.budgetStream$,
      this.paginator, this.sort, this.projectNrPipe);

    if (sessionStorage.getItem('budgetListIconFilter')) {
      this.applyIconFilter(sessionStorage.getItem('budgetListIconFilter'));
    }

    // Add link to balances if user has permission
    this.authService.userHasPermission('app.budget.final.read')
    .subscribe((val) => {
      if (val && !this.displayedColumns.includes('balances')) {
        this.displayedColumns.push('balances');
      } else {
        const index =  this.displayedColumns.indexOf('balances');
        if (index !== -1) {
          this.displayedColumns.splice(index, 1);
        }
      }
    });
  }

  private scrollHandler(event){
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    sessionStorage.setItem('budgetListScrollPosition', top.toFixed(0));

  }

  public ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollHandler, true); 
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }


  public setBudgets(data) {
    return [];
  }

  public onActivate(event) {
    console.log('Activate Event', event);
    if (event.type && event.type === 'click') {
      const dest = '/budget/' + event.row.id;
      this.router.navigate([dest]);
    }
  }

  public goToBudget(row: Budget) {
    const dest = '/budget/' + row.id;
    this.router.navigate([dest]);
  }

  public onSelect(event) {
    console.log('Event: select', event);
  }

  public displayAuthor(b: Budget) {
    return author(b);
  }

}

// Display utility
function author(b: Budget) {
  return b.assignee ? b.assignee.displayName : b.author ? b.author.displayName : '';
}



// Thanks to:
// https://stackoverflow.com/questions/47230980/angular-material-data-table-with-filtering-using-firestore

/**
* Data source to provide what data should be rendered in the table. Note that the data source
* can retrieve its data in any way. In this case, the data source is provided a reference
* to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
* the underlying data. Instead, it only needs to take the data and send the table exactly what
* should be rendered.
*/
class BudgetDataSource extends DataSource<Budget> {

  _filterChange = new BehaviorSubject('');
  _showExport = new BehaviorSubject(false);
  _iconFilterChange = new BehaviorSubject('');

  _dataChange = new BehaviorSubject([]);
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  get showExport(): boolean { return this._showExport.value; }
  set showExport(se: boolean) { this._showExport.next(se); }

  get iconFilter(): string { return this._iconFilterChange.value; }
  set iconFilter(iconFilter: string) { this._iconFilterChange.next(iconFilter); }

  // The number of issues returned by github matching the query.
  public resultsLength = 0;
  public isLoadingResults = false;

  constructor(private observable,
    private _paginator: MatPaginator,
    private _sort: MatSort,
    private projectNrPipe:  ProjectNrPipe
  ) {
    super();
    this.observable.subscribe(this._dataChange);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Budget[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.observable,
      this._sort.sortChange,
      this._filterChange.debounceTime(500),
      this._iconFilterChange.debounceTime(500),
      this._showExport,
      this._paginator.page,
    ];

    this._paginator._changePageSize(Number(localStorage.getItem('budgetListPageSize')))
    this._paginator.page.next(new PageEvent());
    this._paginator.page.subscribe(paginationData => {
      localStorage.setItem('budgetListPageSize',paginationData.pageSize);
    })

    const sortId = localStorage.getItem('budgetListSortId');
    const sortDirection = localStorage.getItem('budgetListSortDirection');

    this._sort.sort(({ id: sortId, start: sortDirection }) as MatSortable);

    return Observable.merge(...displayDataChanges).map(() => {

      const data = this._dataChange.value;
      // console.log('Combine ', data);
      // Filter
      const fData = data.filter((item: Budget) => {

        let searchStr = item.budgetNr + author(item);
        if (item.project) {
          searchStr += this.projectNrPipe.transform(item);
        }
        if (item.prosperworks && item.prosperworks.company_name) {
          searchStr += item.prosperworks.company_name;
        } else if (item.companyName) {
          searchStr += item.companyName;
        }
        if (item.project && item.project.projectManager) {
          searchStr += item.project.projectManager.displayName;
        }
        if (item.assignee) {
          searchStr += item.assignee.displayName;
        }
        if (item.prosperworks) {
          searchStr += item.prosperworks.name;
        }
        else {
          searchStr += item.description
        }
        searchStr = searchStr.toLowerCase();

        let iconSearchStr = item.status == undefined ? 'default' : item.status;
        iconSearchStr = iconSearchStr.toLowerCase();
        
        return (searchStr.indexOf(this.filter.toLowerCase()) !== -1 && iconSearchStr.indexOf(this.iconFilter.toLowerCase()) !== -1) && (this.showExport || (!item.export));
      });

      this.resultsLength = fData.length;
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      
      
      this.sortData(fData);
      return fData.splice(startIndex, this._paginator.pageSize);
    });

  }

  disconnect() { }

  private sortData = (budget: Budget[]) => {
     

    localStorage.setItem('budgetListSortId', this._sort.active);
    localStorage.setItem('budgetListSortDirection', this._sort.direction);

    if (this._sort.active === undefined || this._sort.direction === undefined) {
      return;
    }
    budget.sort((a, b) => {

      let propertyA: number | string | Date = '';
      let propertyB: number | string | Date = '';

      switch (this._sort.active) {
        case 'budgetNr': [propertyA, propertyB] = [a.budgetNr, b.budgetNr]; break;
        case 'manager':
          propertyA = a.project ? (a.project.projectManager ? a.project.projectManager.displayName : '') : '';
          propertyB = b.project ? (b.project.projectManager ? b.project.projectManager.displayName : '') : '';
          break;
        case 'projectNr':
          // propertyA = a.project ? this.projectNrPipe.transform(a) : '';
          // propertyB = b.project ? this.projectNrPipe.transform(b) : '';
          propertyA = a.project ? a.project.projectNr : '';
          propertyB = b.project ? b.project.projectNr : '';
          break;
        case 'author': [propertyA, propertyB] = [a, b].map(author); break;
        case 'category': [propertyA, propertyB] = [a.category, b.category]; break;
        case 'creation': [propertyA, propertyB] = [a.creation, b.creation]; break;
        case 'deliveryThr': [propertyA, propertyB] = [a.deliveryThr, b.deliveryThr]; break;
      }

      let valueA;
      let valueB;

      if (this._sort.active === 'projectNr') {
        // do not try to parse number for projectNr
        valueA = propertyA;
        valueB = propertyB;
      } else if (propertyA instanceof Date || propertyB instanceof Date) {
        valueA = propertyA === undefined ? new Date(0) : propertyA;
        valueB = propertyB === undefined ? new Date(0) : propertyB;
      } else {
        valueA = isNaN(+propertyA) ? propertyA : +propertyA;
        valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      }

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/budget/budget-list.component.ts